import { defineAsyncComponent } from 'vue'
export default {
  bare: defineAsyncComponent(() => import("/opt/simploshop/themes/theme-default-clean/app/layouts/bare.vue")),
  "c-root": defineAsyncComponent(() => import("/opt/simploshop/themes/theme-default-clean/app/layouts/c-root.vue")),
  cart: defineAsyncComponent(() => import("/opt/simploshop/themes/theme-default-clean/app/layouts/cart.vue")),
  customer: defineAsyncComponent(() => import("/opt/simploshop/themes/theme-default-clean/app/layouts/customer.vue")),
  default: defineAsyncComponent(() => import("/opt/simploshop/themes/theme-default-clean/app/layouts/default.vue"))
}